import React from 'react'
import { twMerge } from 'tailwind-merge'
import { useConfig } from 'msp-integrations'
import * as T from './RadioButton.types'
import * as S from './RadioButton.styles'

const RadioButton = ({
  checkedValue = undefined,
  disabled = false,
  id,
  label,
  onChange,
  value,
  registered = false,
  className = '',
  isDarkMode = false,
  isValueVariant = false,
  ...rest
}: T.RadioButtonProps) => {
  const {
    theme: {
      mspComponents: { radiobutton }
    }
  } = useConfig()

  const radioButtonStyle = radiobutton.getStyles(isDarkMode)
  const classNameStyle = isValueVariant
    ? 'appearance-none'
    : `${S.defaultRadio} ${radioButtonStyle.initial} ${radioButtonStyle.checked} ${radioButtonStyle.disabled}`

  const isChecked = value === checkedValue
  const props: T.RadioInputProps = {
    className: classNameStyle,
    disabled,
    onChange,
    type: 'radio',
    value,
    id,
    ...(registered ? { checked: isChecked } : { defaultChecked: isChecked }),
    ...rest
  }

  return (
    <label
      className={
        isValueVariant
          ? radioButtonStyle.labelValueVariant
          : `${radioButtonStyle.label} ${className}`
      }
    >
      <input {...props} />
      <span
        className={
          isValueVariant
            ? twMerge(
                radioButtonStyle.labelWrapperValueVariant,
                isChecked && 'bg-black text-white'
              )
            : radioButtonStyle.labelWrapper
        }
      >
        {label}
      </span>
    </label>
  )
}

export default RadioButton
